// extracted by mini-css-extract-plugin
export default {"container":"take-livepoll-for-zoom_container__jRwXN","closeIcon":"take-livepoll-for-zoom_closeIcon__ko7lL"};